import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BsEnvelopeOpen } from "react-icons/bs";
import { TiGroupOutline } from "react-icons/ti";
import { FaStethoscope } from "react-icons/fa";
import { AiOutlineGift } from "react-icons/ai";
import DashLayout from "../../layouts/DashLayout";
import { useDispatch, useSelector } from "react-redux";
import { getLetters } from "../../store/actions/LetterActions";
import { getFunds } from "../../store/actions/FundActions";
import { getBeneficiries } from "../../store/actions/BenActions";
import { getStocks } from "../../store/actions/StoreActions";
import { getAssocciations } from "../../store/actions/AssocciationsActions";
import { getMeetings } from "../../store/actions/MeetingsActions";
import { getVisits } from "../../store/actions/VisitActions";
import { getYearEvents } from "../../store/actions/YearEventActions";
import { getSaturdayStudies } from "../../store/actions/SstudiesActions";
import ContentLoader from "react-content-loader";
import { capitalizeFirstLetter } from "../../utils/CapitalizeFirstLetter";
import Table from "../../components/Table";
import Action from "../../components/HomePageAction";

function Home() {
  const dispatch = useDispatch();
  const stores = useSelector((state) => state.stockState.stocks);
  const funds = useSelector((state) => state.fundsState.funds);

  const userName = JSON.parse(
    `${useSelector((state) => state.auth.session)}`
  ).username;

  // table columns
  const beneficiriesColumns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "BenId",
        accessor: "benId",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Service",
        accessor: "service",
      },
      {
        Header: "Modification",
        accessor: "change",
      },
      {
        Header: "ModifiedAt",
        accessor: "modificationDate",
      },
      {
        Header: "ModifiedBy",
        accessor: "modifiedBy",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );
  const loaders = useSelector((state) => state.loadersState);
  const benefs = useSelector((state) => state.beneficiries);
  useEffect(() => {
    dispatch(getBeneficiries());
    dispatch(getFunds());
    dispatch(getLetters());
    dispatch(getStocks());
    dispatch(getAssocciations());
    dispatch(getYearEvents());
    dispatch(getMeetings());
    dispatch(getVisits());
    dispatch(getSaturdayStudies());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const assocciations = useSelector(
    (state) => state.stateOfAssociations.assocciations
  );
  const meetingsEvents = useSelector((state) => state.meetingState.meetings);
  const visitsEvents = useSelector((state) => state.visitState.visits);
  const satStudyEvents = useSelector(
    (state) => state.saturdayStudiesEventState.saturdayStudies
  );
  const yearEvents = useSelector((state) => state.yearEventState.yearEvents);
  const events =
    meetingsEvents.length +
    visitsEvents.length +
    satStudyEvents.length +
    yearEvents.length;

  // transforming results
  let [loadedBeneficiaries, setBeneficiries] = useState([]);
  useEffect(() => {
    setBeneficiries([]);
    for (let i = 0; (i < benefs.length) & (i < 6); i++) {
      const ourBeneficary = {
        count: i + 1,
        id: benefs[i].id,
        benId: benefs[i].beneficiaryCode,
        name: `${benefs[i].firstName} ${benefs[i].lastName}`,
        service: "Insurance",
        change: (
          <div
            className={
              "px-2 rounded bg-indigo-100 text-indigo-500  fit-content flex"
            }
          >
            <p>{"Update"}</p>
          </div>
        ),
        modifiedBy: "Fiston fle",
        modificationDate: (
          <p className="fit-content font-semibold">{"2 days ago"}</p>
        ),
        benStatus: (
          <div className={"py-1 px-2 rounded   fit-content flex"}>
            <p>{capitalizeFirstLetter(benefs[i].status)}</p>
          </div>
        ),
        action: <Action benId={benefs[i].id} />,
      };

      setBeneficiries((loadedBeneficiaries) => [
        ...loadedBeneficiaries,
        ourBeneficary,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benefs]);

  let [loadingBeneficiaries, setLoadingBeneficiries] = useState([]);

  useEffect(() => {
    setLoadingBeneficiries([]);
    for (let i = 0; i < 5; i++) {
      const ourBeneficary = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        benId: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 50 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="60" height="7" />
          </ContentLoader>
        ),
        name: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 100 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="90" height="7" />
          </ContentLoader>
        ),
        change: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        service: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        modifiedBy: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        modificationDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 90 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="60" height="7" />
          </ContentLoader>
        ),
      };

      setLoadingBeneficiries((loadingBeneficiaries) => [
        ...loadingBeneficiaries,
        ourBeneficary,
      ]);
    }
  }, [loaders.fetchingBeneficiriesLoaders]);
  return (
    <DashLayout>
      <div className="py-0 px-10">
        <div className="w-full p-3 bg-indigo-100 mb-3 rounded">
          <h2 className="text-indigo-500 font-semibold">
            <span className="font-semibold">
              {capitalizeFirstLetter(userName)}
            </span>{" "}
            welcome to RW0622 workspace
          </h2>
        </div>
        <div className="flex flex-col md:flex-row    mt-1 w-full">
          <div className="flex w-full md:w-1/2">
            {/* overview card */}
            <Link
              to="/services/letters"
              className="border border-indigo-50  bg-indigo-500 hover:bg-indigo-300 text-gray-500 p-5 pl-2 lg:pl-5 md:mr-2 md:m-auto rounded flex flex-row w-1/2   cursor-pointer"
            >
              <div className="flex">
                <div className="rounded-full bg-white w-10 h-10 lg:w-14 lg:h-14 flex">
                  <BsEnvelopeOpen className="m-auto text-md md:text-xl text-indigo-500" />
                </div>
                <div className="m-auto flex flex-col pl-2 pr-4 text-white">
                  <p className="text-xs font-semibold">Store</p>
                  <span className="text-xs">{stores.length}</span>
                </div>
              </div>
            </Link>
            {/* overview card */}
            <Link
              to="/services/funds"
              className="border border-white bg-white hover:bg-gray-200 hover:border-gray-100 text-gray-500 p-5 pl-2 lg:pl-5 ml-2 md:mr-2 md:m-auto rounded flex flex-row w-1/2   cursor-pointer"
            >
              <div className="flex">
                <div className="rounded-full bg-gray-300  text-white w-10 h-10 lg:w-14 lg:h-14 flex">
                  <AiOutlineGift className="m-auto text-md md:text-xl" />
                </div>
                <div className="m-auto flex flex-col pl-2 pr-4">
                  <p className="text-xs font-semibold">Funds </p>
                  <span className="text-xs">{funds.length}</span>
                </div>
              </div>
            </Link>
          </div>
          <div className="flex w-full md:w-1/2 mt-5 md:mt-0 md:ml-2">
            {/* overview card */}
            <Link
              to="/services/events"
              className="border border-white bg-white hover:bg-gray-200 hover:border-gray-100 text-gray-500 p-5 pl-2 lg:pl-5 mr-1 lg:mr-2 rounded flex flex-row w-1/2  cursor-pointer"
            >
              <div className="flex">
                <div className="rounded-full bg-gray-300  text-white w-10 h-10 lg:w-14 lg:h-14 flex">
                  <FaStethoscope className="m-auto text-md md:text-xl" />
                </div>
                <div className="m-auto flex flex-col pl-2 pr-4">
                  <p className="text-xs font-semibold">Events</p>
                  <span className="text-xs">{events}</span>
                </div>
              </div>
            </Link>
            {/* overview card */}
            <Link
              to="/assocciations"
              className="border border-white bg-white hover:bg-gray-200 hover:border-gray-100 text-gray-500 p-5 pl-2 lg:pl-5 md:m-auto mr-0 rounded flex flex-row w-1/2  cursor-pointer"
            >
              <div className="flex">
                <div className="rounded-full bg-gray-300 text-white w-10 h-10 lg:w-14 lg:h-14 flex">
                  <TiGroupOutline className="m-auto text-md md:text-xl" />
                </div>
                <div className="m-auto flex flex-col pl-2 pr-4">
                  <p className="text-xs font-semibold">Assocciations</p>
                  <span className="text-xs">{assocciations.length}</span>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <div className="pt-5 mt-5 mb-5 rounded flex bg-white">
          {/* beneficiries table */}
          <div className="w-full">
            {!loaders.fetchingBeneficiriesLoaders &&
            loadedBeneficiaries.length < 1 ? (
              <div
                className={
                  !loaders.fetchingBeneficiriesErroredMessage
                    ? "bg-gray-100 fit-content  text-xs rounded text-center my-5 py-2 px-4 text-gray-500 font-semibold m-auto"
                    : "bg-red-100 text-xs rounded fit-content text-center my-5 py-2 px-4 text-red-500 font-semibold m-auto"
                }
              >
                <p>
                  {!loaders.fetchingBeneficiriesErroredMessage
                    ? "No recent action record found"
                    : loaders.fetchingBeneficiriesErroredMessage}
                </p>
              </div>
            ) : (
              <div>
                <div className="flex flex-col md:flex-col w-full">
                  <h2 className="font-semibold mx-10 py-1">
                    Last Modified Beneficiaries Profile
                  </h2>{" "}
                </div>
                <div className="mr-10">
                  <Table
                    data={
                      loaders.fetchingBeneficiriesLoaders
                        ? loadingBeneficiaries
                        : loadedBeneficiaries
                    }
                    columns={beneficiriesColumns}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashLayout>
  );
}

export default Home;
